@use "../../../styles/breakpoint.module.scss" as *;

.card {
    display: grid;
    grid-template-columns: 40% 1fr;
    column-gap: var(--spacer-24);
    align-items: start;
    padding: var(--spacer-24);

    @media ($below-tablet) {
        grid-template-columns: 30% 1fr;
    }

    @media ($below-mobile) {
        grid-template-columns: 1fr;
    }
}

.open {
    padding: 0;
}

.noImage {
    grid-template-columns: 1fr;
}

.imageWrapper {
    aspect-ratio: 3 / 4;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media ($below-mobile) {
        width: 50%;
        margin: 0 auto var(--spacer-24);
    }
}

.content {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.headline {
    composes: fontHB48 from "../../../styles/typography.module.scss";
    margin-bottom: var(--spacer-16);
}

.body {
    composes: fontP20 from "../../../styles/typography.module.scss";
}

.bodyContained {
    flex-grow: 1;
    display: flex;
    align-items: flex-start;
}

.ctaWrapper {
    margin-top: var(--spacer-24);
}

.ctaWrapperContained {
    margin-top: var(--spacer-32);
}
